/* Vue  ++++++++++++++++++++++++++++++++++++++++++*/
import axios from 'axios';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';

const Vue = require('vue');

const {
    ref, onMounted, computed, watch,
} = Vue;
const App = {
    setup() {
        const projects = ref([]);
        const allLocations = ref([]);
        const currentLocation = ref(null);
        const glonalsInit = ref(false);

        window.vueInitMapGlobal = () => {
            glonalsInit.value = true;
        };

        // Projects
        const filteredProjects = computed(() => projects.value.filter(
            (project) => {
                if (!currentLocation.value) return true;

                let locationCheck = false;
                project.locationTax.forEach((location) => {
                    if (location.term_id === currentLocation.value) {
                        locationCheck = true;
                    }
                });

                return locationCheck;
            }
        ));

        onMounted(async() => {
            await getProjects();

            const tempLocations = [];
            for (let projectI = 0; projectI < projects.value.length; projectI++) {
                const project = projects.value[projectI];

                for (let locationI = 0; locationI < project.locationTax.length; locationI++) {
                    const location = project.locationTax[locationI];
                    if (!tempLocations.includes(location.term_id)) {
                        tempLocations.push(location.term_id);
                        allLocations.value.push(location);
                    }
                }
            }

            getGeoJson();
        });

        watch(filteredProjects, () => {
            if (mapIsLoaded && filteredProjects.value.length) {
                updateMap();
            }
        });

        async function getProjects() {
            let currentLang = '';
            // eslint-disable-next-line no-undef
            if (wp_urls.currentLang && wp_urls.currentLang !== 'de') {
                // eslint-disable-next-line no-undef
                currentLang = `/${wp_urls.currentLang}`;
            }

            const getUrl = `${window.location.origin}${currentLang}
/wp-json/wp/v2/projects?_embed=1&_fields=title,id,thumb,permalink,acf,locationTax&per_page=9999`;

            await axios.get(getUrl).then((response) => {
                projects.value = response.data;
            }).catch((error) => {
                console.log(error.toJSON()); // eslint-disable-line no-console
            });
        }

        // ############### Map Box Functions ###############
        const geojson = {
            type: 'FeatureCollection',
            features: [],
        };
        let bounds = [];
        const accessToken = 'pk.eyJ1IjoiaGVycmxpY2gtbWVkaWEiLCJhIjoiY2p0dTU4ZDRrMHBxbjQ0bXBlM3NjOTN5ayJ9.JS1FNS6PTcpcMlj_pHfVYQ';  // eslint-disable-line max-len
        const mapStyle = 'mapbox://styles/herrlich-media/ckv9livdr1ez314s05jilt56l';
        const mapContainer = 'projectMap__container';
        let map = '';
        let mapIsLoaded = false;
        const currentMarkers = [];

        function getGeoJson() {
            gatherGeoJson();

            // Init Map
            if (glonalsInit.value) {
                initMap(geojson.features[0].geometry.coordinates);

                map.on('load', async() => {
                    mapLoaded();
                });
            } else {
                watch(glonalsInit, () => {
                    initMap(geojson.features[0].geometry.coordinates);

                    map.on('load', async() => {
                        mapLoaded();
                    });
                });
            }
        }

        function gatherGeoJson() {
            // Sammel alle Daten
            bounds = [];
            geojson.features = [];

            const data = filteredProjects.value;
            for (let i = 0; i < filteredProjects.value.length; i += 1) {
                const coordinates = [
                    parseFloat(data[i].acf.long, 10),
                    parseFloat(data[i].acf.lat, 10),
                ];
                const featuresData = {
                    type: 'Feature',
                    geometry: {
                        type: 'Point',
                        coordinates,
                    },
                    properties: {
                        title: data[i].title.rendered,
                        permalink: data[i].permalink,
                        thumb: data[i].thumb,
                        realization: data[i].acf.overviewSubtitle,
                    },
                };
                bounds.push(coordinates);
                geojson.features.push(featuresData);
            }
        }

        function updateMap() {
            gatherGeoJson();

            map.getSource('locations').setData(geojson);
            addMarkers(geojson);
            fitMapToFeatures(geojson);
        }

        function initMap(center) {
            // Set center
            mapboxgl.accessToken = accessToken;

            // Create Map Box Object & Options
            map = new mapboxgl.Map({
                container: mapContainer,
                style: mapStyle,
                center,
                zoom: 6,
            });

            // Add zoom and rotation controls to the map.
            map.addControl(new mapboxgl.NavigationControl(), 'top-left');
        }

        function mapLoaded() {
            mapIsLoaded = true;

            map.addSource('locations', {
                type: 'geojson',
                data: geojson,
            });

            addMarkers(geojson);

            updateMap();
        }

        function fitMapToFeatures(featuresToFit) {
            bounds = new mapboxgl.LngLatBounds();
            if (featuresToFit.type === 'FeatureCollection') {
                featuresToFit.features.forEach((feature) => {
                    bounds.extend(feature.geometry.coordinates);
                });
            } else {
                featuresToFit.geometry.coordinates[0].forEach((coordinate) => {
                    bounds.extend(coordinate);
                });
            }
            map.fitBounds(bounds, {
                padding: 100
            });
        }

        function addMarkers(data) {
            if (currentMarkers !== null) {
                for (let i = currentMarkers.length - 1; i >= 0; i -= 1) {
                    currentMarkers[i].remove();
                }
            }
            /* For each feature in the GeoJSON object above: */
            data.features.forEach((marker) => {
                /* Create a div element for the marker. */
                const el = document.createElement('div');
                /* Assign a unique `id` to the marker. */
                el.id = `marker-${marker.properties.id}`;
                /* Assign the `marker` class to each marker for styling. */
                el.className = 'marker';
                /* *
               * Create a marker using the div element
               * defined above and add it to the map.
               * */
                const oneMarker = new mapboxgl.Marker(el, { offset: [0, -33.5] })
                    .setLngLat(marker.geometry.coordinates).setPopup(new mapboxgl.Popup({ offset: 0 })
                        .setHTML(`<div class="postContent listElement">
                            <a target="_blank" href="${marker.properties.permalink}">
                                <div class="postContent__img mb-2 ">
                                <img src="${marker.properties.thumb}" alt="${marker.properties.title}" />
                                </div>
                                <div class="postContent__content pb-2">
                                    <h4>${marker.properties.title}</h4>
                                    <p>Realisierung ${marker.properties.realization}</p>            
                                </div>
                            </a>
                        </div>`))
                    .addTo(map);
                currentMarkers.push(oneMarker);
            });
        }

        return {
            filteredProjects,
            allLocations,
            currentLocation,
            accessToken,
            mapStyle,
        };
    }
};

Vue.createApp(App).mount('#projectMap');
// }); /* ready end ++++++++++++++++++++++++++++++++++++++++++*/
